export enum PatronState {
  WaitingForChart = 'WAITING_FOR_CHART',
  WaitingForTriage = 'WAITING_FOR_TRIAGE',
  Waiting = 'WAITING',
  MeetingRequest = 'MEETING_REQUEST',
  InMeeting = 'IN_MEETING',
  InGroupMeeting = 'IN_GROUP_MEETING',
  InSurvey = 'IN_SURVEY',
  PostTriage = 'POST_TRIAGE',
  Completed = 'COMPLETED',
  Ejected = 'EJECTED',
  Left = 'LEFT',
}
